/**
 * Reducer for explore airbnb
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import produce from 'immer'
import merge from 'lodash/merge'
import uniq from 'lodash/uniq'
import {
  FETCH_EXPLORE_AIRBNB_SUCCESS,
  FETCH_MORE_EXPLORE_AIRBNB_SUCCESS
} from '../types'

const initialState = {
  rooms: {},
  roomsOrder: []
}

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_EXPLORE_AIRBNB_SUCCESS:
      merge(draft, action.data)
      break
    case FETCH_MORE_EXPLORE_AIRBNB_SUCCESS:
      const { roomsOrder, ...updatedAirbnbData } = action.data ?? {}
      const updatedRoomsOrder = uniq(draft.roomsOrder.concat(roomsOrder))
      updatedAirbnbData.roomsOrder = updatedRoomsOrder

      merge(draft, updatedAirbnbData)
      break
  }
}, initialState)
